import './App.css';
import { ConfigProvider } from 'antd';
import { App as ThemeProvider } from 'antd/';
import { useContext } from 'react';
import { IntlProvider } from 'react-intl';
import { Route, Routes, useNavigate } from 'react-router-dom';
import Login from '@/app/Login/Login.tsx';
import { SessionGate } from '@/auth/components/SessionGate';
import { locale } from '@/settings/locale.ts';
import ErrorPage from '@/shared/Components/ErrorPage/ErrorPage.tsx';
import NotFound from '@/shared/Components/NotFound/NotFound.tsx';
import { Context } from '@/store/Context.tsx';
import { AntdLayerProvider } from '@/styles/antd-layer.tsx';
import { getAntdTheme } from '@/styles/theme/antd-theme.ts';
import { ThemeBridge } from '@/styles/theme/theme-bridge.tsx';
import RecoverPassword from './app/Login/RecoverPassword.tsx';
import ResetPassword from './app/Login/ResetPassword.tsx';
import Privacy from './app/Privacy/Privacy.tsx';
import Terms from './app/Terms/Terms.tsx';
import { PrivateRoutes, PublicRoutes } from './routes/guards.tsx';
import LayoutTemplate from './shared/Components/LayoutTemplate/LayoutTemplate.tsx';

// const [language] = (navigator.language || 'es').split('-');
const language = 'es';

function App() {
  const { error, setAppError, isDark } = useContext(Context);
  const navigate = useNavigate();

  const handleError = () => {
    if (error) {
      setAppError();
      switch (error.code) {
        case 999:
          navigate('/login');
      }
    }
  };

  if (error?.isSessionExpired)
    return (
      <AntdLayerProvider>
        <ErrorPage title={error.title} subTitle={error.message} onClick={handleError} />
      </AntdLayerProvider>
    );

  return (
    <AntdLayerProvider>
      <IntlProvider locale={language} messages={locale[language]?.messages || {}} defaultLocale="es">
        <ConfigProvider locale={locale[language].locale || locale.es.locale} theme={getAntdTheme(isDark)}>
          <ThemeBridge />
          <ThemeProvider>
            <Routes>
              {/* RUTAS UNIVERSALES */}
              <Route path="/Privacy" element={<Privacy />} />
              <Route path="/Terms" element={<Terms />} />
              {/* RUTAS PÚBLICAS CON VERIFICACIÓN DE SESIÓN*/}
              <Route element={<SessionGate />}>
                <Route element={<PublicRoutes />}>
                  <Route path="/login" element={<Login />} />
                  <Route path="/recuperar" element={<RecoverPassword />} />
                  <Route path="/restablecer" element={<ResetPassword />} />
                </Route>
                <Route element={<PrivateRoutes />}>
                  <Route path="/" element={<LayoutTemplate />} />
                </Route>
              </Route>
              {/* <Route path="/" element={<LayoutTemplate />} /> */}
              {/* <Route path="/unauthorized" element={<Unauthorized title="No tienes los permisos necesarios" />} /> */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </ThemeProvider>
        </ConfigProvider>
      </IntlProvider>
    </AntdLayerProvider>
  );
}

export default App;
